import React, { useEffect, useState } from "react";
import {
  Button,
  Chip,
  InfoText,
  InfoTimeCardAdv,
  InfoWrapper,
  LogoLoader,
  Modal,
  NewTab,
  StatusTags,
} from "../../../../components";
import { formatWords, keyToTitle } from "../../../../utils";
import Activities from "./JobDetail/Activities";
import { useLocation, useNavigate } from "react-router-dom";
import Info from "./JobDetail/Info";
import TalentMatch from "./JobDetail/TalentMatch";
import Shortlisted from "./JobDetail/Shortlisted";
import Pipeline from "./JobDetail/Pipeline";
import Submission from "./JobDetail/Submission";
import JobCampaign from "./JobDetail/JobCampaign";
import SmartInsights from "./JobDetail/SmartInsights";
import QueryString from "./JobDetail/QueryString";
import ResumeMining from "./JobDetail/ResumeMining";
import SimilarSubmission from "./JobDetail/SimilarSubmission";
import QualifyingQuestions from "./JobDetail/QualifyingQuestions";
import {
  fetchJobCardCounts,
  fetchJobPost,
  fetchJobPostingSmartInsights,
  talentMatchCountPercentage,
} from "../../../../redux/slices/bdmjobs/bdmjobsApi";
//import EditModal from "./Modals/EditModal";
import { useModuleAccess } from "../../../../hooks";
import AddJobPost from "../../AccountDetails/AccountDetail/Modals/AddJobPost";
import { useDispatch, useSelector } from "react-redux";
//import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import { getTotalCountApi } from "../../../../redux/slices/totalCount/totalCountApi";
import { convertFromUTC } from "../../../../utils/dateUtils";
import { formatWords2 } from "../../../../utils/stringUtils";
import AiCalls from "./JobDetail/AiCalls";
import { getBdmSettingsApi } from "../../../../redux/slices/setting/settingApi";

const JobDetails = () => {
  // const { uiid } = useParams();
  const location1 = useLocation();
  const [prevPath, setPrevPath] = useState(location1.pathname);
  const { applicantId } = location1.state || "";
  //  let { uiid } = location1.state || {};
  let uiid = sessionStorage.getItem("selectedJobUiid");
  const prevPage = sessionStorage.getItem("prevJobsPage");
  //const dispatch = useDispatch();
  const [jobDetails, setJobDetails] = useState(null);
  const [jobSmartInsights, setJobSmartInsights] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [talentMatchCount, setTalentMatchCount] = useState(0);
  const navigate = useNavigate();
  // console.log("jobDetails",jobDetails)
  const jobInfo = jobDetails?.jobInfo || {};
  const skills = jobDetails?.skills || {};
  // const orgInform = jobDetails?.orgInform || {};
  const location = jobInfo?.location || {};
  const { user } = useSelector((state) => state.auth);
  const [talentMatchData, setTalentMatchData] = useState(null);
  const [newSubmissionIds, setNewSubmissionIds] = useState([]); // required when transfer talentMatch to shortlisted
  const [resumeMiningAccess, setResumeMiningAccess] = useState(false);
  const [jobCardCounts, setJobCardCounts] = useState({
    shortlistedCount: 0,
    pipelineCount: 0,
    submittedCount: 0,
    confirmedCount: 0,
    interviewCount: 0,
  });
  const getDaysSinceAdded = (dateString) => {
    if (!dateString) return null;
    const createdDate = new Date(dateString);
    const today = new Date();

    // Calculate difference in days
    const diffTime = today - createdDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return "Opened today";
    if (diffDays === 1) return "Opened 1 day ago";
    return `Opened ${diffDays} days ago`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const JobPostingStatus = {
    1: "Draft",
    2: "Active",
    3: "On Hold",
    4: "Hold by Client",
    5: "Interview L1",
    6: "Interview L2",
    7: "Interview L3",
    8: "Priority",
    9: "Filled",
    10: "Closed",
    11: "Agreement Sent",
    12: "Agreement Accepted",
  };
  const ApplicantSubStatus = {
    1: "Shortlisted",
    2: "Pipeline",
    3: "Submitted",
    4: "Review call by BDM",
    5: "BDM Interview",
    6: "Disqualified",
    7: "Hold",
    8: "Withdrawn",
    9: "Waiting for Writeup",
    10: "Submitted to Client",
    11: "Submitted To Vendor",
    12: "Shortlisted for Interview",
    13: "Interview Confirmation",
    14: "Interview Scheduled",
    15: "L1 Interview Scheduled",
    16: "L2 Interview Scheduled",
    17: "L3 Interview Scheduled",
    18: "L1 Interview Selected",
    19: "L2 Interview Selected",
    20: "L3 Interview Selected",
    21: "L1 Interview Rejected",
    22: "L2 Interview Rejected",
    23: "L3 Interview Rejected",
    24: "L1 Interview Re-Scheduled",
    25: "L2 Interview Re-Scheduled",
    26: "L3 Interview Re-Scheduled",
    27: "L1 Interview Feedback Pending",
    28: "L2 Interview Feedback Pending",
    29: "L3 Interview Feedback Pending",
    30: "Rejected By Client",
    31: "Selected but no response from the client",
    32: "Rejected after Client Selection",
    33: "Submitted to End Client",
    34: "Vendor Interview",
    35: "Vendor Interview Reject",
    36: "Client Interview",
    37: "Client Interview Select",
    38: "Client Interview Reject",
    39: "Client Interview Completed",
    40: "End Client Interview",
    41: "End Client Interview Completed",
    42: "Selected By Vendor",
    43: "Selected By Client",
    44: "Selected By End Client",
    45: "Rejected By Vendor",
    46: "Rejected by End Client",
    47: "Disqualified By Vendor",
    48: "Disqualified By Client",
    49: "Disqualified by End Client",
    50: "Hold By Vendor",
    51: "Hold By Client",
    52: "Hold by End Client",
    53: "Drop",
    54: "Position on Hold",
    55: "PW Interview Proposed By Buyer",
    56: "PW Interview Proposed By Supplier",
    57: "PW Interview Failed",
    58: "PW Interview Cancelled",
    59: "PW Interview Success",
    60: "Assignment Contract Sent",
    61: "Assignment Contract Verified",
    62: "Assignment Contract Rejected",
    63: "Confirmed",
    64: "Position Filled",
    65: "Backout",
    66: "Not Joined",
    67: "BGV Failed",
    68: "Got Pay Rate Confirmation",
    69: "Offer Withdrawn",
    70: "Negotiation",
    71: "Start",
    72: "Offer Sent",
    73: "Offer Accepted",
    74: "Offer Rejected",
    75: "Hold with Client",
    76: "Hold with Vendor",
  };
  function buildJobTimeline(jobData) {
    const timeline = [];

    console.log(jobDetails, "jobDetails")

    if (jobDetails?.jobId?.companyId) {
      console.log("company detailssssssssssss",jobDetails )
      timeline.push({
        task: "Company Created",
        taskBy:
          jobDetails?.jobId?.companyId?.addedBy && jobDetails?.jobId?.companyId?.addedBy
            ? formatWords2(jobDetails?.jobId?.companyId?.addedBy?.firstName)
            : formatWords2(jobDetails?.jobId?.companyId?.addedBy?.firstName || ""),
        designation: formatWords2(jobDetails?.jobId?.companyId?.addedBy?.role?.name || ""),
        taskDate: convertFromUTC(jobDetails?.jobId?.companyId?.addedOn),
        applicant: "N/A",
      });
    }

    if (jobDetails?.jobId) {
      timeline.push({
        task: "Company Added",
        taskBy:
          jobDetails?.jobId?.addedBy && jobDetails?.jobId?.addedBy
            ? formatWords2(jobDetails?.jobId?.addedBy?.firstName)
            : formatWords2(jobDetails?.jobId?.addedBy?.firstName || ""),
        designation: formatWords2(jobDetails?.jobId?.addedBy?.role?.name || ""),
        taskDate: convertFromUTC(jobDetails?.jobId?.addedOn),
        applicant: "N/A",
      });
    }

    if (jobDetails?.addedOn) {
      timeline.push({
        task: "JobPost Created",
        taskBy:
          jobDetails?.addedBy && jobDetails?.addedBy?.firstName
            ? formatWords2(jobDetails?.addedBy?.firstName)
            : formatWords2(jobDetails?.addedBy || ""),
        designation: formatWords2(jobDetails?.addedBy?.role?.name || ""),
        taskDate: convertFromUTC(jobDetails?.addedOn),
        applicant: "N/A",
        jobPostId: jobInfo?.jobCode,
        recruiter: jobDetails?.notifyTo?.map(rec => formatWords2(rec?.firstName)).join(", ")
      });
    }

    if (
      Array.isArray(jobData?.statusHistory) &&
      jobData?.statusHistory?.length > 0
    ) {
      jobData?.statusHistory?.forEach((sh) => {
        timeline.push({
          task: formatWords2(JobPostingStatus[sh?.status]) || sh?.status,
          taskBy: formatWords2(sh?.addedBy?.firstName || sh?.addedBy),
          designation: formatWords2(sh?.addedBy?.role?.name || ""),
          taskDate:convertFromUTC(sh?.addedOn),
          applicant: "N/A",
          jobPostId: jobInfo?.jobCode,
          recruiter: formatWords2(sh?.addedBy?.firstName || sh?.addedBy),
        });
      });
    }
    if (Array.isArray(jobData?.submissions) && jobData.submissions.length > 0) {
      jobData.submissions.forEach((sub) => {
        const candidateId = sub?.candidateId || "";

        if (Array.isArray(sub?.statusHistory) && sub.statusHistory.length > 0) {
          sub.statusHistory.forEach((sh) => {
            const addedBy = sh?.addedBy || {};
            timeline.push({
              task: ApplicantSubStatus[sh?.status] || sh.status,
              taskBy: formatWords2(addedBy?.firstName || addedBy),
              designation: formatWords2(addedBy?.role?.name || ""),
              taskDate: convertFromUTC(sh?.addedOn),
              applicant: candidateId
                ? formatWords2(candidateId?.firstName) + " " + formatWords2(candidateId?.lastName)
                : "N/A",
              recruiter: formatWords2(addedBy?.firstName || addedBy),
              jobPostId: jobInfo?.jobCode,
            });
          });
        }
      });
    }

    timeline.sort((a, b) => new Date(b.taskDate) - new Date(a.taskDate));

    return timeline;
  }
  const activities = buildJobTimeline(jobDetails);

  const latestStatusCode =
    jobDetails?.statusHistory?.length > 0 &&
    jobDetails.statusHistory[jobDetails.statusHistory.length - 1].status;

  const latestStatus = JobPostingStatus[latestStatusCode] || "Active";
  // useEffect(() => {
  //   return () => {
  //     sessionStorage.removeItem("selectedJobUiid");
  //   };
  // }, []);

  useEffect(() => {
    return () => {
      const nextPath = window.location.pathname;

      if (nextPath !== prevPath) {
        sessionStorage.removeItem("selectedJobUiid");
      }
    };
  }, [location.pathname]);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await getBdmSettingsApi({ coll: "Setting", lim: 1 });
        const settings = response?.data?.data?.[0];
        if (settings?.resumeMiningSettings?.access) {
          const { byRoleIds, byUserIds } = settings.resumeMiningSettings.access;
          // Strict rule: if no role/user configured, hidden for everyone
          if ((!byRoleIds || byRoleIds.length === 0) && (!byUserIds || byUserIds.length === 0)) {
            setResumeMiningAccess(false);
          } else {
            const userRole = user?.data?.role?.uiid;
            const userId = user?.data?.uiid;
            const hasAccess =
              (byRoleIds && byRoleIds.includes(userRole)) ||
              (byUserIds && byUserIds.includes(userId));
            setResumeMiningAccess(hasAccess);
          }
        } else {
          setResumeMiningAccess(false);
        }
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };
    fetchSettings();
  }, [user]);

  const infoCardDetails = [
    { title: "Talent Match", value: talentMatchCount || 0 },
    { title: "Shortlisted", value: jobCardCounts?.shortlistedCount || 0 },
    { title: "Pipeline", value: jobCardCounts?.pipelineCount || 0 },
    { title: "Submitted", value: jobCardCounts?.submittedCount || 0 },
    { title: "Interviews", value: jobCardCounts?.interviewCount || 0 },
    { title: "Confirmed", value: jobCardCounts?.confirmedCount || 0 },
  ];

  const getJobCardCounts = async () => {
    try {
      const response = await fetchJobCardCounts({
        coll: "JobPosting",
        fil: JSON.stringify({
          uiid: { type: "SUBMISSION_STATUS_COUNT", value: Number(uiid) },
        }),
        useAggregate: true,
      });

      if (response?.data?.data?.[0]) {
        setJobCardCounts(response.data.data?.[0]);
      }
    } catch (err) {
      console.error("Error fetching job card counts:", err);
    }
  };

  const getJobDetails = async () => {
    try {
      const response = await fetchJobPost({
        coll: "JobPosting",
        // ret: "uiid jobInfo skills orgInform jobId status addedOn addedBy",
        // ref: "Job Note Submission",
        ref: "Job Submission",
        extret: "uiid firstName role",
        fil: { uiid: { type: "NONE", value: uiid } },
        extincl: "uiid name",
        // incl: ["", "uiid statusHistory.status statusHistory.addedBy statusHistory.addedOn candidateId addedBy"]
      });

      if (response?.data) {
        setJobDetails(response?.data?.data);
      }
    } catch (err) {
      console.error("Error fetching job details:", err);
    } finally {
      setLoading(false);
    }
  };

  const jobPostMenus = [
    {
      title: "Info",
      page: <Info jobDetails={jobDetails} />,
      type: "main",
      id: "jobsdetailsuiid_info",
    },
    {
      title: "Talent Match",
      page: <TalentMatch jobPostId={uiid} TalentMatchIds={jobDetails?.talentMatch?.ids || []} refreshCounts={getJobCardCounts} onShortlistSuccess={(ids) => setNewSubmissionIds((prev) => [...prev, ...ids])} />,
      type: "main",
      id: "jobsdetailsuiid_talentmatch",
    },
    {
      title: "Shortlisted",
      page: <Shortlisted 
      // submissions={jobDetails?.submissions || []} 
      submissions={[
        ...(jobDetails?.submissions || []),
        ...newSubmissionIds,
      ]}
      refreshCounts={getJobCardCounts} />,
      type: "main",
      id: "jobsdetailsuiid_shortlisted",
    },
    {
      title: "Pipeline",
      page: <Pipeline 
      // submissions={jobDetails?.submissions || []} 
      submissions={[
        ...(jobDetails?.submissions || []),
        ...newSubmissionIds,
      ]}
      />,
      type: "main",
      id: "jobsdetailsuiid_pipeline",
    },
    {
      title: "Submission",
      page: <Submission submissions={jobDetails?.submissions || []} />,
      type: "main",
      id: "jobsdetailsuiid_submission",
    },
    {
      title: "Activities",
      page: <Activities activities={activities || []} />,
      type: "main",
      id: "jobsdetailsuiid_activities",
    },
    {
      title: "Job Campaign",
      page: <JobCampaign selectedJobUiid={uiid} />,
      type: "main",
      id: "jobsdetailsuiid_jobcampaign",
    },
    {
      title: "Smart Insights",
      page: (
        <SmartInsights
          jobSmartInsights={jobSmartInsights}
          skills={skills?.primarySkills || []}
          jobPostId={jobDetails?.uiid}
        />
      ),
      type: "main",
      id: "jobsdetailsuiid_smartinsights",
    },
    {
      title: "Query String",
      page: <QueryString />,
      type: "main",
      id: "jobsdetailsuiid_querystring",
    },
    {
      title: "Resume Mining",
      page: <ResumeMining jobId={uiid} jobDetails={jobDetails} />,
      type: "main",
      id: "jobsdetailsuiid_resumemining",
    },
    {
      title: "Similar Submission",
      page: <SimilarSubmission jobPostId={jobDetails?.uiid} />,
      type: "main",
      id: "jobsdetailsuiid_similarsubmission",
    },
    {
      title: "Qualifying Questions",
      page: <QualifyingQuestions jobPostId={jobDetails?.uiid} />,
      type: "main",
      id: "jobsdetailsuiid_qualifyingquestions",
    },
    {
      title: "AI Calls",
      page: <AiCalls jobPostId={jobDetails?.uiid} />,
      type: "main",
      id: "jobsdetailsuiid_aicalls",
    },
  ];

  /*
  // Filter out Resume Mining if no access
  const visibleMenus = jobPostMenus.filter(menu => {
    if (menu.title === "Resume Mining" && !resumeMiningAccess) {
      return false;
    }
    return true;
  });
  */

  const moduleTabs = useModuleAccess({
    allTabs: jobPostMenus,
    parentId: "jobsdetailsuiid",
  });

  const filteredTabs = moduleTabs.filter(menu => {
    if (menu.title === "Resume Mining" && !resumeMiningAccess) {
      return false;
    }
    return true;
  });

  let generalJobDetails = [

    {
      "Job Title": formatWords2(jobDetails?.jobId?.title || "N/A"),
      Location: `${formatWords2(location?.city || "N/A")}, ${formatWords2(location?.state || "N/A")}`,
      Position: jobInfo?.type || "N/A",
      "Position Opened": jobInfo?.reqHourWeek || "N/A", // doubt
      "Position Closed": jobInfo?.duration || "N/A", // doubt
    },
  ];

  let secondaryDetails = [

    {
      "Show Created by": formatWords2(jobDetails?.addedBy?.firstName || "N/A"),
      "Modified by": formatWords2(jobDetails?.jobId?.modifiedBy?.firstName || "N/A"),
      "Created on": jobDetails?.addedOn
        ? formatDate(convertFromUTC(jobDetails.addedOn))
        : "N/A",
      "Modified On": jobDetails?.updatedAt
        ? formatDate(convertFromUTC(jobDetails.updatedAt))
        : "N/A",
      "Talent Match(Count of Candidate)": talentMatchData || [
        { count: "0", percentage: "80-100%", color: "primary" },
        { count: "0", percentage: "50-80%", color: "info" },
        { count: "0", percentage: "< 50%", color: "leave" },
      ],
    },
  ];

  const handleJobBoardsClick = () => {
    if (prevPage === "/ats/jobs?jobs=all-jobs") {
      navigate("/ats/jobs?job-boards=internal-db&jobs=job-boards");
      return;
    }

    if (prevPage === "/ats/recruitment/jobs?recruitment_jobs=all-jobs") {
      navigate("/ats/applicants?applicants=job-boards&applicants-jobboards=internal-db");
      return;
    }

    if (prevPage === "/ats/recruitment/jobs?recruitment_jobs=my-jobs") {
      navigate("/ats/applicants?applicants=job-boards&applicants-jobboards=internal-db");
      return;
    }
    if (user?.data?.role?.type == 4) {
      navigate(
        "/ats/applicants?applicants=job-boards&applicants-jobboards=internal-db"
      );
      return
    }
    navigate("/ats/jobs?job-boards=internal-db&jobs=job-boards");
  };

  const getTalentPercentage = async () => {
    try {
      const response = await talentMatchCountPercentage({
        coll: "TalentMatche",
        fil: JSON.stringify({
          jobPostId: {
            type: "TM_SKILLMATCHPERCENT_COUNT",
            value: Number(uiid),
          },
        }),
        useAggregate: true,
      });

      if (response?.data?.data?.[0]) {
        const res = response?.data.data[0];
        const total = res?.totalCount || 0;

        const talentMatch = [
          {
            count: `${res["80-100"]}/${total}`,
            percentage: "80-100%",
            color: "primary",
          },
          {
            count: `${res["50-80"]}/${total}`,
            percentage: "50-80%",
            color: "info",
          },
          {
            count: `${res["0-50"]}/${total}`,
            percentage: "< 50%",
            color: "leave",
          },
        ];

        setTalentMatchData(talentMatch);
      }
    } catch (err) {
      console.error("Error fetching Talent Match count:", err);
    }
  };
  useEffect(() => {
    if (!uiid) {
      setLoading(false);
      if (window.history.state && window.history.state.idx > 0) {
        navigate(-1);
      } else {
        navigate("/ats/jobs?jobs=all-jobs");
      }
      return;
    }
    if (uiid) {
      getJobDetails();
      getJobCardCounts();
      getTalentPercentage();
    }
  }, [uiid]);

  useEffect(() => {
    const fetchTalentMatchCount = async () => {
      try {
        if (jobDetails?.talentMatch?.ids?.length > 0) {
          const res = await getTotalCountApi({
            collection: "talentmatches",
            coll: "TalentMatche",
            app: "ats",
            filters: {
              uiid: { type: "IN", value: jobDetails.talentMatch.ids },
            },
          });
          setTalentMatchCount(res?.data?.data || 0);
        }
      } catch (error) {
        console.error("Error fetching Talent Match count:", error);
      }
    };
    fetchTalentMatchCount();
  }, [jobDetails]);

  // For Smart Insights
  useEffect(() => {
    const getJobSmartInsightsDetails = async () => {
      try {
        const response = await fetchJobPostingSmartInsights({
          coll: "JobPosting",
          fil: {
            uiid: {
              type: "AG_JOBPOSTING_SMART_INSIGHTS",
              value: "",
              jobPostId: jobDetails?.uiid,
            },
          },
          useAggregate: true,
          queryMode: "AG_JOBPOSTING_SMART_INSIGHTS"
        });

        if (response?.data) {
          setJobSmartInsights(response?.data.data[0]);
        }
      } catch (err) {
        console.error("Error fetching job smart insights details:", err);
      } finally {
        setLoading(false);
      }
    };

    if (jobDetails) {
      getJobSmartInsightsDetails();
    }
  }, [jobDetails]);
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <LogoLoader />
      </div>
    );
  }
  if (!jobDetails) {
    return <div className="p-4 text-red-500">No job found for this ID.</div>;
  }

  // console.log(jobDetails)
  return (
    <div className="flex flex-col gap-5 flex-1">
      <div className="flex justify-between items-center mr-4 mt-3">
        <Button
          title="Job Post Details"
          color="black"
          variant="text"
          size="md"
          fromLeft
          icon="arrow_left_alt"
          className="self-start text-md font-semibold"
          // onClick={() => {
          //   navigate("/ats/jobs#draft-jobs");
          // }}
          // onClick={() => {
          //   if (window.history.state && window.history.state.idx > 0) {
          //     navigate(-1);
          //   } else {
          //     navigate("/ats/jobs?jobs=all-jobs");
          //   }
          // }}
          onClick={() => {
            if (prevPage) {
              if (prevPage?.includes("applicants/applicant-details")) {
                navigate(prevPage, {state: {applicantId}})
              } else {
                navigate(prevPage);
              }
            } else {
              navigate("/ats/jobs?jobs=all-jobs");
            }
          }}
        />
        <div className="flex gap-2">
          {user?.data?.role?.type === 3 && jobDetails?.addedBy?.uiid === user?.data?.uiid &&
            <Button
              variant="outlined"
              title={"Edit"}
              icon={"edit_square"}
              onClick={() => setOpenEditModal(true)}
            />
          }

          <Button title={"Job Boards"} onClick={handleJobBoardsClick} />
        </div>
      </div>

      <div className="flex justify-between items-center gap-1 mx-1">
        <div className="flex gap-2 items-center">
          <h6 className="subtitle-reg ml-3 mr-1">
            {/* {formatWords("NESU-070433-729843286906423")} */}
            {formatWords(jobInfo?.jobCode)}
          </h6>
          <p className=" text-xs font-[600] text-gray-400 mr-3">
            {/* (Opened 3 days ago) */}({getDaysSinceAdded(jobDetails?.addedOn)}
            )
          </p>
          <StatusTags icon size="lg" tag={latestStatus} />
        </div>
      </div>
      <div className=" mx-3 grid grid-cols-4 md:grid-cols-1 xl:grid-cols-3 gap-5 my-1 inner-section p-4 rounded">
        {Object.entries(generalJobDetails[0]).map(([key, value]) => {
          return (
            <InfoText
              size="sm"
              key={key}
              title={keyToTitle(key)}
              value={value}
            />
          );
        })}
      </div>
      <div className="mx-3 flex gap-5 my-1 inner-section p-4 rounded">
        <div className="grid md:grid-cols-2 xl:grid-cols-4 lg:grid-cols-3 gap-5">
          {Object.entries(secondaryDetails[0]).map(([key, value]) => {
            const isTalentMatch = key === "Talent Match(Count of Candidate)";
            const displayValue = isTalentMatch ? (
              <div className="flex gap-3">
                {value.map((data, index) => (
                  <div className="flex flex-col gap-2 items-center" key={index}>
                    <Chip
                      key={index}
                      label={data.count}
                      color={data.color}
                      variant="outlined"
                      size="lg"
                      className={`!px-4 py-3 rounded-xl bg-${data?.color}-50 !text-xs`}
                    />
                    <div className="text-xs">{data?.percentage}</div>
                  </div>
                ))}
              </div>
            ) : (
              value
            );

            return (
              <div className={isTalentMatch ? "col-span-3" : ""} key={key}>
                <InfoText
                  size="sm"
                  title={keyToTitle(key)}
                  value={displayValue}
                />
              </div>
            );
          })}
        </div>
      </div>

      {/* <div className="grid grid-cols-6 gap-4 mx-3"> */}
      <InfoWrapper>
        {infoCardDetails.map((item) => (
          <InfoTimeCardAdv
            title={item.title}
            value={item.value}
            variant={"text"}
            color={"primary"}
            size="sm"
          />
        ))}
      </InfoWrapper>

      <div className="flex-1 mx-3 rounded-xl">
        <NewTab
          tabs={filteredTabs}
          color="gray"
          variant="text"
          activeVariant="text"
          mode="url"
          tabId="job-details"
        />
      </div>

      <Modal
        isOpen={openEditModal}
        onClose={() => setOpenEditModal(false)}
        title={"Edit"}
        titleColor={"primary"}
        // width="max-w-4xl"
        width="w-full"
      >
        {/* <EditModal onCancel={() => setOpenEditModal(false)} /> */}
        <AddJobPost
          onCancel={() => setOpenEditModal(false)}
          editData={jobDetails}
          onSuccess={() => {
            setOpenEditModal(false);
            getJobDetails();
          }}
        />
      </Modal>
    </div>
  );
};

export default JobDetails;
